/**
 * Strip out EVERYTHING except alphanumeric characters.
 * Allow for chars like ǎ, ť and other non-standard chars.
 * So the thinking is that if we just boil each Node down to its
 * alphabet and numbers, that should give an accurate enough
 * comparison, while stripping out problematic orphan Text Nodes,
 * or floating periods, punctuation etc.
 */
const normalizeText = (text = "") => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\p{L}\p{N}]+/gu, "");
};

export default normalizeText;
